import { MoveRelease } from '../../../store/actions';

import * as storymapStoreModule from '../../../store';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import {
    MoveReleaseToIndex,
    ArchiveRelease as ArchiveReleaseCommand,
    RemoveRelease,
    ChangeReleaseName,
    AddNewRelease,
    ReactivateRelease,
    PushCardsToIntegrationTool,
} from '..';
import { SaveNewRelease } from '../../../store/actions/releases/saveNewRelease';

export const createMoveReleaseToIndexCommand = async (action: MoveRelease) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const release = state.releases.find((x) => x.id === action.id);

    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        ReleaseId: action.id,
        ReleaseName: release.name,
        Position: action.order,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.ReleaseMovedToIndex,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new MoveReleaseToIndex(state.id, release.id, action.order);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createArchiveReleaseCommand = async (storymapId: string, releaseId: string, releaseName: string) => {
    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: storymapId,
        ReleaseId: releaseId,
        ReleaseName: releaseName,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.ReleaseArchived,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new ArchiveReleaseCommand(storymapId, releaseId);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createRestoreReleaseCommand = async (storymapId: string, releaseId: string, releaseName: string) => {
    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: storymapId,
        ReleaseId: releaseId,
        ReleaseName: releaseName,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.ReleaseReactived,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new ReactivateRelease(storymapId, releaseId);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createDeleteReleaseCommand = async (storymapId: string, releaseId: string, releaseName: string, moveCardsToId: string) => {
    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: storymapId,
        ReleaseId: releaseId,
        ReleaseName: releaseName,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.ReleaseDeleted,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new RemoveRelease(storymapId, releaseId, moveCardsToId);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createRenameReleaseCommand = async (id: string, storymapId: string, name: string, oldName: string) => {
    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: storymapId,
        ReleaseId: id,
        ReleaseName: name,
        OriginalContent: oldName,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.ReleaseNameChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new ChangeReleaseName(storymapId, id, name);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createCreateReleaseCommand = async (action: SaveNewRelease) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        ReleaseId: action.id,
        ReleaseName: action.name,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.ReleaseCreated,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new AddNewRelease(state.id, action.id, action.name, action.order);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createPushAllCardsOfReleaseCommand = async (
    storymapId: string,
    releaseId: string,
    releaseName: string,
    externalToolName: string
) => {
    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        ExternalToolName: externalToolName,
        Id: activityId,
        StorymapId: storymapId,
        ReleaseId: releaseId,
        ReleaseName: releaseName,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.CardsPushedToIntegrationTool,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new PushCardsToIntegrationTool(storymapId, releaseId);
    cmd.BoardActivity = boardActivity;

    return cmd;
};
